export const newMessageMessageStateEnum = Object.freeze({
    "EMPTY": 1,
    "PENDING": 2,
    "UNSUCCESSFULLY_SENT": 3,
    "SUCCESSFULLY_SENT": 4
});